import React from 'react';
import styled from 'styled-components';
import Container from '../../styled/Container';
import { H3 } from '../../styled/Heading';
import { theme } from '../../styled/layout/theme';
import { test_ids } from '../../../tests/test_ids';
interface IPanel {
  title?: string;
  content?: string | React.ReactNode;
  buttons?: JSX.Element | JSX.Element[];
  fullHeight?: boolean;
  children?: React.ReactNode;
}

const buttonContainerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
};

const CookieDiv = styled.div`
  max-width: 1920px;
  background-color: white;
  width: 100%;
  bottom: 0;
  position: fixed;
  z-index: ${theme.layers.cookieConsent};
  padding: 20px;
  color: black;
  -webkit-box-shadow: 5px 0px 15px 0px rgba(0, 0, 0, 0.14);
  box-shadow: 5px 0px 15px 0px rgba(0, 0, 0, 0.14);
`;

const CookieBanner = ({ title, children, content, buttons }: IPanel) => {
  return (
    <CookieDiv data-testid={test_ids.cookies.cookieBanner}>
      <Container>
        <H3>{title}</H3>
        {children}
        <div>{content}</div>
        <div style={buttonContainerStyle}>{buttons}</div>
      </Container>
    </CookieDiv>
  );
};

export default CookieBanner;
